import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";
import { logOut } from './../util'
import { Checkbox, FormControlLabel } from '@mui/material';

export default function CreateAttributeDialog({ token, setToken, open, setOpen, setAttributeList }) {
    const [nameInput, setNameInput] = useState('')
    const [createAnother, setCreateAnother] = useState(false)
    let navigate = useNavigate()

    function handleClose() {
        setOpen(false)
    }

    const handleInputChange = (event) => {
        setNameInput(event.target.value);
    };

    const handleKeyPress = event => {
        if (event.key === 'Enter')
            handleSubmit()
    }

    function handleSubmit() {
        let status;
        fetch('/api/attributes', {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            },
            body: JSON.stringify({
                name: nameInput,
                type: "string"
            })
        })
            .then(response => {
                status = response.status;
                return response.json();
            })
            .then(json => {
                if (status !== 200) {
                    if (status === 401) {
                        console.log(status)
                        logOut({ navigate, setToken })
                    }
                    return console.log(json.message);
                }
                setAttributeList(attributes => [...attributes, json]);
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                setNameInput('')
                if (!createAnother) {
                    handleClose()
                }
            })
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth >
            <DialogTitle>Create Attribute</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Attributes are used to tag scans
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    value={nameInput}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyPress}
                    placeholder='Seating Zone'
                    autoComplete='off'
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <FormControlLabel
                    label="Create another"
                    // sx={{ mb: 2 }}
                    control={
                        <Checkbox
                            checked={createAnother}
                            onChange={() => setCreateAnother(val => !val)}
                            inputProps={{ 'aria-label': 'Create another' }}
                        />
                    }
                />
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={handleSubmit}>Create</Button>
            </DialogActions>
        </Dialog>
    );
}
